import React, { useState } from "react";
import { X, Loader2 } from "lucide-react";
import { Button } from "../ui/Button";
import FormField from "../ui/FormField";

interface SendReminderModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSend: (text: string) => void;
  title?: string;
  recipientLabel?: string;
  isLoading?: boolean;
}

export const SendReminderModal: React.FC<SendReminderModalProps> = ({
  isOpen,
  onClose,
  onSend,
  title = "Send Reminder/Offers",
  isLoading = false,
}) => {
  const [text, setText] = useState("");
  const wordLimit = 500;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSend(text);
    setText("");
    // onClose(); // Handled by parent on success
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black/40 z-50"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-xl shadow-lg w-full max-w-lg flex flex-col mx-4"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header - Matching Theme */}
        <div className="px-6 py-4 border-b border-[#885ABB] flex justify-between items-center bg-[#885ABB] rounded-t-xl">
          <h2 className="text-xl font-bold text-white flex-1">{title}</h2>
          <button
            onClick={onClose}
            className="text-white/80 hover:text-white hover:bg-white/10 p-1 rounded-full transition-colors"
          >
            <X size={24} />
          </button>
        </div>

        {/* Content */}
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div className="space-y-2">
            <FormField
              label="Enter Text:"
              name="reminderText"
              type="textarea"
              value={text}
              onChange={(_, val) => setText(val)}
              className="min-h-[150px]"
              placeholder=""
              disabled={isLoading}
            />
            <div className="flex justify-between items-center text-xs text-gray-500">
              <span>
                Words limit: {text.length}/{wordLimit}
              </span>
            </div>
          </div>

          {/* Footer */}
          <div className="flex justify-end gap-3 pt-2">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              className="border-gray-300 text-gray-700 hover:bg-gray-50 bg-white"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              disabled={isLoading || !text.trim()}
              className={`${isLoading ? "opacity-70 cursor-not-allowed" : ""
                } bg-[#885ABB] hover:bg-[#6f47a2] text-white flex items-center gap-2 justify-center`}
            >
              {isLoading ? (
                <>
                  <Loader2 className="h-4 w-4 animate-spin" />
                  <span>Sending...</span>
                </>
              ) : (
                "Send"
              )}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};
